import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { useAuthMember, useDeleteMember } from '@tribeplatform/react-sdk/hooks'
import { ActionPanel } from '@tribeplatform/react-ui-kit/ActionPanel'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { confirm } from '@tribeplatform/react-ui-kit/Dialog'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const DeleteAccount = () => {
  const { $t } = useI18n()
  const { data: member, isAdmin } = useAuthMember()
  const { mutateAsync: deleteMember } = useDeleteMember()
  const { redirect } = useRouter()

  const [canRemoveMember] = hasScopesPermission(member, ['removeMember'])

  if (!canRemoveMember) {
    return null
  }

  return (
    <ActionPanel
      title={<T defaultMessage="Delete account" id="Settings.DeleteAccount" />}
      description={
        isAdmin ? (
          <T
            defaultMessage="Community owner and admins cannot delete their own accounts."
            id="Settings.DeleteAccount.AdminsProhibited"
          />
        ) : (
          <T
            defaultMessage="Deactivate and remove your account from the community."
            id="Settings.DeleteAccount.Description"
          />
        )
      }
      placement="trailing-top"
    >
      <Button
        size="lg"
        variant="secondaryNeutral"
        disabled={isAdmin}
        onClick={async () => {
          const confirmed = await confirm({
            title: $t({
              defaultMessage: 'Are you sure you want to delete your account?',
              id: 'Settings.DeleteAccount.Confirmation.Title',
            }),
            description: $t({
              defaultMessage: 'This action is not reversible.',
              id: 'Settings.DeleteAccount.Confirmation.Description',
            }),
            proceedLabel: $t({
              defaultMessage: 'Delete my account',
              id: 'Settings.DeleteMyAccount',
            }),
            cancelLabel: $t({
              defaultMessage: 'Cancel',
              id: 'Generics.Cancel',
            }),
            danger: true,
          })
          if (confirmed) {
            await deleteMember({ id: member?.id })
            toast({
              title: $t({
                defaultMessage: 'Account deleted',
                id: 'Settings.DeleteAccount.Success',
              }),
              status: 'success',
            })
            redirect('/')
          }
        }}
      >
        <T defaultMessage="Delete my account" id="Settings.DeleteMyAccount" />
      </Button>
    </ActionPanel>
  )
}
